import { useState, useEffect, useRef } from 'react'
import OtpInput from 'react-otp-input'
import { BASE_URL } from '../../utils/api'
import { ErrorNotification, SuccessNotification } from '../../utils'
import axios from 'axios'

const OtpForm = ({ setActiveStep, activeStep, email }) => {
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [passwordLoading, setPasswordLoading] = useState(false)
  const [waitTime, setWaitTime] = useState(30) // initial wait time in seconds
  const [currentWait, setCurrentWait] = useState(0)
  const [resendCount, setResendCount] = useState(0)
  const timerRef = useRef(null)

  useEffect(() => {
    if (currentWait > 0) {
      timerRef.current = setInterval(() => {
        setCurrentWait((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current)
            return 0
          }
          return prev - 1
        })
      }, 1000)
    }
    return () => clearInterval(timerRef.current)
  }, [currentWait])

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const { data } = await axios.post(`${BASE_URL}auth/password/verifyresetcode/`, {
        otp_code: otp,
      })

      if (data) {
        SuccessNotification(data?.message || "Code verified successfully. You can now reset your password")
        setActiveStep(activeStep + 1)
      } else {
        ErrorNotification(data.error)
      }
    } catch (error) {
      ErrorNotification(error.response.data.error)
    } finally {
      setLoading(false)
    }
  }

  const resendCode = async () => {
    setPasswordLoading(true)
    let payload = {
      email: localStorage.getItem("email")
    }

    try {
      const { data } = await axios.post(`${BASE_URL}auth/password/requestreset/`, payload)
      if (data) {
        SuccessNotification(data.message || `We've sent a 6-digit verification code to ${payload.email}`)
        setResendCount((prev) => prev + 1)
        setWaitTime((prev) => prev + 30)
        setCurrentWait(waitTime + 30)
        setPasswordLoading(false)
      } else {
        ErrorNotification(data.error)
        setPasswordLoading(false)
      }
    } catch (error) {
      setPasswordLoading(false)
      ErrorNotification(error?.response?.data?.error || error?.message)
    }
  }

  return (
    <div className='w-full'>
      <div className="my-7 w-full">
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderSeparator={<span></span>}
          renderInput={(props) => <input
            {...props}
            className='w-full font-normal bg-white dark:bg-secondaryDark border dark:border-border-dark dark:text-white rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-yellowcolor focus:border-transparent placeholder-gray-400'
          />}
          inputStyle={{
            width: '100%',
            height: '65px',
            fontSize: '16px',
            fontWeight: 'normal',
            border: '2px solid #E5B117',
            borderRadius: '8px',
            padding: '10px 0',
          }}
          containerStyle={{
            display: 'flex',
            alignItems: 'center',
            gap: 5
          }}
        />
      </div>

      <div className="my-4 space-y-4">
        <button
          disabled={loading || otp.length !== 6}
          onClick={handleSubmit}
          type="submit"
          className="bg-yellowcolor w-full capitalize hover:bg-yellowcolor/90  text-black font-normal py-3 px-10 rounded-md"
        >
          <p>{loading ? "Please wait..." : "Verify"} </p>
        </button>

        <div className="flex items-center justify-center">
          <button
            onClick={resendCode}
            disabled={passwordLoading || currentWait > 0}
            className="w-full outline-none border-none flex flex-row items-center justify-center text-center font-normal text-black dark:text-white mt-2">
            Didn't receive code?&nbsp;
            <p className={`text-yellowcolor hover:underline font-medium underline ${passwordLoading ? "text-gray-500" : ""}`}>
              {passwordLoading
                ? "Please wait..."
                : currentWait > 0
                  ? `Resend in ${currentWait}s`
                  : "Resend code"}
            </p>
          </button>
        </div>
      </div>
    </div>
  )
}

export default OtpForm